module.exports = __webpack_public_path__ + "img/SYM03.ce560ff6.gif";